import React, { useState, useEffect, useRef } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import choVayConst, { LaiSuatText3 } from "constants/choVayConst";
import { formatNumber } from "utils/currencyFormat";
import XuatExcelApi from "../../../../service/xuatExcelApi"
import ChiTietCuaHangApi from "../../../../service/chiTietCuaHangApi"
export const XuatExcelTaiSan = (props) => {
    const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };
    const componentRef = useRef();
    const [tongBanGhi, setTongBanGhi] = useState(0);
    const [danhSachTaiSan, setDanhSachTaiSan] = useState([]);
    const [percent, setPercent] = useState(0);
    const [maCuaHang, setMaCuaHang] = useState('');
    const [noidung, setNoiDung] = useState('Đang phân tích dữ liệu. Vui lòng chờ đến khi xuất được tập tài liệu.');
    useEffect(() => {
        let dsTaiSan = [];
        let tong = 0;
        let pageCount = 0;
        let curent = 1;
        let percurent = 0;

        ChiTietCuaHangApi.chiTietCuaHangHienTai().then((response) => {
            setMaCuaHang(response.data.Code);
        });

        XuatExcelApi.kiemTraDuLieuTaiSan(props.dataSearch).then((response) => {
            tong = response.data.TotalQuantity;
            pageCount = Math.ceil(tong / 500);
            let perPage = Math.floor(100 / pageCount);
            if (perPage <= 0)
                perPage = 0.001;
            const fetchData = async () => {
                XuatExcelApi.duLieuTaiSan(
                    props.dataSearch.tentaisan,
                    props.dataSearch.tenkhachhang,
                    props.dataSearch.kho,
                    props.dataSearch.trangthai,
                    props.dataSearch.tinhtrang,
                    props.dataSearch.ghichu,
                    curent,
                ).then((response) => {
                    response.data.List && response.data.List.map((item, index) => (
                        dsTaiSan.push(item)
                    ))
                    curent++;
                    percurent = percurent + perPage;
                    setPercent(percurent);
                    if (curent <= pageCount && props.show) {
                        sleep(1000).then(r => {
                            fetchData();
                        });
                        if (percurent >= 100) {
                            percurent = 80;
                            setPercent(percurent);
                        }
                        if (percurent >= 100) {
                            percurent = 80;
                            setPercent(percurent);
                        }
                    }
                    else {
                        percurent = 100;
                        setPercent(percurent);
                        setNoiDung("Dữ liệu đã tải xong. Vui lòng kiểm tra thư mục download.")
                    }
                    setDanhSachTaiSan(dsTaiSan);
                    if (percurent >= 100 && props.show) {
                        sleep(1500).then(r => {
                            downExcel();
                        });
                    }
                });
            }
            if (percurent === 0 && props.show)
                fetchData();
            setTongBanGhi(response.data.TotalQuantity);

        });


    }, []);
    const downExcel = () => {
        var uri =
            "data:application/vnd.ms-excel;charset=utf-8,%EF%BB%BF" +
            encodeURIComponent(document.getElementById("htmlExcel").innerHTML);
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download =
            "DanhSachTaiSan_" + moment().format("YYYYMMDDHHmm") + ".xls";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    return (
        <>
            <Modal
                show={props.show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="modal-new modal fade text-left"
            >
                <Modal.Header>
                    <h4 className="modal-title" id="myModalLabel16">
                        <span className="btn-icon-right">
                            <i className="mdi mdi-file-document"></i>
                        </span>
                        Xuất excel dữ liệu danh sách tài sản
                    </h4>
                    {percent === 100 && (
                        <button type="button" className="close-popup-new" onClick={props.onHide}>
                            <i className="mdi mdi-close"></i>
                        </button>
                    )}
                </Modal.Header>
                <Modal.Body className="">
                    <div className="form-thongtin-kh-new">
                        <div id="accordionWrap6" role="tablist" aria-multiselectable="true">
                            <div className="card collapse-icon accordion-icon-rotate" style={{ textAlign: "center" }}>
                                {noidung}
                            </div>
                            <div>
                                <div style={{ width: "100%", backgroundColor: "#CCCCCC", height: "20px" }}>
                                    <div style={{ width: percent + "%", backgroundColor: "#006266", height: "20px", textAlign: "center", fontWeight: "bold", color: "#FFF", fontSize: "12px" }}>
                                        {percent} %
                                    </div>
                                </div>
                            </div>
                            <div style={{ overflow: "scroll", display: "none" }} id="htmlExcel">
                                <table style={{ border: "1px solid #CCCCCC", width: "100%", color: "#000000" }}>
                                    <tr style={{ backgroundColor: "#b9edc6", color: "#063e02", fontWeight: "bold" }}>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>STT</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã Tài sản cầm cố</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã hợp đồng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã Tài sản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã Code</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Tên tài sản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Giá thẩm định (VNĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Giá thẩm định đã giảm trừ (VNĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Giá cho vay tôi đa (VNĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Giá cửa hàng đề xuất (VNĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Mã cửa hàng</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Biển Kiểm Soát</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số Khung)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số Máy</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số đăng ký xe</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>IMEI ( Loại TS: ĐT, Laptop)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Serial ( Loại TS: ĐT, Laptop)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số sổ QSDĐ ( Loại TS: Sô NĐ)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số thẻ SV (Loại TS: sinh viên)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Số ĐT ( Loại TS: sim số đẹp)</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Năm sản xuất</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Thuộc tính giảm trừ</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Thông tin tài sản</td>
                                        <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>Ghi chú</td>

                                    </tr>
                                    {danhSachTaiSan && danhSachTaiSan.map((item, index) => (
                                        <tr>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{index + 1}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.MaHopDong}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.MaTaiSan}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.TenTaiSan}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{maCuaHang}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>NULL</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.ThongTinTaiSan}</td>
                                            <td style={{ border: "1px solid #CCCCCC", textAlign: "center" }}>{item.Note}</td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal.Body >
                <Modal.Footer>
                    <div className="text-right">
                        {percent === 100 && (
                            <button
                                type="button"
                                className="btn btn-new-main btn-closenew"
                                onClick={props.onHide}
                            >
                                <span className="btn-icon-left">
                                    <i className="mdi mdi-close"></i>
                                </span>
                                Đóng
                            </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal >
        </>
    );
};
